import React from 'react';
import UniversalLoader from './UniversalLoader';

const LoadingFallback = ({ message = "Loading...", size = 'medium' }) => (
  <UniversalLoader message={message} size={size} />
);

export default LoadingFallback;
